import { configureStore } from '@reduxjs/toolkit';
import appConfigSlice from './appConfigSlice';
 
export const store = configureStore({
  reducer: {
    appConfigSlice: appConfigSlice,
  },
});
 
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;